export default function Menu() {

    let menu__buttons = document.querySelector('.b-header__mob-actions'),
        menu__button = menu__buttons.querySelector('.i__menu'),
        links = document.querySelectorAll('.b-header__menu ul li a');

    menu__button.addEventListener('click', (e) => {
        e.preventDefault();

        if (!menu__button.classList.contains('i__menu--active')) {
            menu__button.classList.add('i__menu--active');
            menuStatus(true);
            buttonMenuStatus(true);
        } else {
            menuStatus(false);
            buttonMenuStatus(false);
        }
    })

    links.forEach(link => {
        link.addEventListener('click', (e) => {
            menuStatus(false);
            buttonMenuStatus(false);
            console.log('close menu')
        })
    })

    function menuStatus(status) {
        let menu_container = document.querySelector('.b-header__menu');
        if (status) {
            menu_container.classList.add('b-header__menu--active')
        } else {
            menu_container.classList.remove('b-header__menu--active')
        }
    }

    function buttonMenuStatus(status) {
        let menu__button = menu__buttons.querySelector('.i__menu');
        if (status) {
            menu__button.classList.add('i__menu--active');
        } else {
            menu__button.classList.remove('i__menu--active')
        }
    }
}